import { FC, useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import { PickerProps, hourItems, minuteItems } from './_models';
import { useNavigationData } from '../../../modules/NavigationProvider';
import TimePicker from '../../../components/TimePicker';

const PickerComponent: FC<PickerProps> = ({
  time: {
    startHour,
    setStartHour,
    startMinute,
    setStartMinute,
    stopHour,
    setStopHour,
    stopMinute,
    setStopMinute,
  },
  ledDays,
  setShowPicker,
  onCancel,
  onSave,
}) => {
  const { t } = useTranslation('schedule');
  const { setHeaderText } = useNavigationData();
  const [state, setState] = useState<boolean>(true);

  useLayoutEffect(() => {
    setHeaderText(t('title.schedule'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const weekdays = [
    t('sunday'),
    t('monday'),
    t('tuesday'),
    t('wednesday'),
    t('thursday'),
    t('friday'),
    t('saturday'),
  ];

  return (
    <div
      className="d-flex flex-column w-100 gap-3"
      style={{ maxWidth: '400px' }}
    >
      <div>
        <Button
          variant="outline-dark"
          size="sm"
          className="w-100 text- text-uppercase"
          onClick={() => setShowPicker(false)}
        >
          <div className="d-flex justify-content-between">
            <span>{t('repeat')}</span>
            <span>
              {t(
                ledDays.length === 7 || ledDays.length === 0
                  ? 'always'
                  : weekdays
                      .filter((_, index) => ledDays.includes(index))
                      .map((day) => day.slice(0, 3))
                      .join(', ')
              )}
            </span>
          </div>
        </Button>
      </div>
      <TimePicker
        hourItems={hourItems}
        hourValue={state ? startHour || 0 : stopHour || 0}
        onHourChange={state ? setStartHour : setStopHour}
        minuteItems={minuteItems}
        minuteValue={state ? startMinute || 0 : stopMinute || 0}
        onMinuteChange={state ? setStartMinute : setStopMinute}
      />
      <div className="d-flex justify-content-between">
        <Button
          variant="outline-dark"
          size="sm"
          className="text-uppercase"
          onClick={onCancel}
        >
          {t('cancel')}
        </Button>

        <Button
          variant="outline-dark"
          size="sm"
          className={`text-uppercase ${state ? 'active' : ''}`}
          onClick={() => setState(true)}
        >
          {t('start')}
        </Button>

        <Button
          variant="outline-dark"
          size="sm"
          className={`text-uppercase ${!state ? 'active' : ''}`}
          onClick={() => setState(false)}
        >
          {t('end')}
        </Button>

        <Button
          variant="outline-dark"
          size="sm"
          className="text-uppercase"
          onClick={onSave}
        >
          {t('save')}
        </Button>
      </div>
    </div>
  );
};

export default PickerComponent;
